function Spacer(){
    return (
    // padding-top: ;
        <div style={{minHeight: 'min(23vw, 140px)'}}>

        </div>
    )
}

export default Spacer;